import React, { useState } from 'react';
import { ImageComponent, ImageContainer, SkeletonContainer } from './Image.styles';

function Image({ src, alt, className, onClick, disabled }) {
  const [loaded, setLoaded] = useState(false);

  const handleImageLoaded = () => {
    setLoaded(true);
  };

  return (
    <ImageContainer className={className} onClick={onClick} $cursorPointer={!!onClick && !disabled}>
      {!loaded && <SkeletonContainer $animationTime={6} />}
      <ImageComponent src={src} alt={alt} onLoad={handleImageLoaded} style={{ display: loaded ? 'block' : 'none' }} />
    </ImageContainer>
  );
}

export default Image;
